import dompurify from "isomorphic-dompurify";

import { useTranslations } from "@jti/ui";

const { sanitize } = dompurify;

type SummaryCartItemsTrialsBadgeType = {
  isFreeTrial: boolean;
  className: string;
};

const SummaryCartItemsTrialsBadge = ({ isFreeTrial, className }: SummaryCartItemsTrialsBadgeType) => {
  const { __ } = useTranslations();

  if (!isFreeTrial) {
    return null;
  }

  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: sanitize(__("cart.payment_summary.freeTrials")) }} />
  );
};

export default SummaryCartItemsTrialsBadge;
